import client from "@/clients/PlanningClient";
import { EmploymentTypeDto } from "@/models/planning/EmploymentTypeDto";

const resource = '/EmploymentType';

export const EmploymentTypeRepository = {
  getAll: () => client.get(`${resource}`) as Promise<{data: EmploymentTypeDto[]}>
}
